import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatagridService } from '../../../../shared/index';
import { PagedResult } from '../../../../shared/model/generic-paged-result.model';
import { NavigationService } from '../../../../shared/navigation/navigation.service';
import { MassCommService, Message, SentMessageStatistics, CommunicationRecordSearch, CommunicationRecord } from '../../../shared/index';

/**
 * message analytics (for not-drafts)
 */
@Component({
  selector: 'wl-mass-comm-message-edit-analytics-delivery-details',
  templateUrl: 'mass-comm-message-edit-analytics-delivery-details.component.html',
  styleUrls: [],
  providers: [],
    standalone: false
})
export class MassCommMessageEditAnalyticsDeliveryDetailsComponent {
  @Input() public messageId: number = 0;

  public isSearching: boolean = false;
  public isExporting: boolean = false;

  public recipientResult: PagedResult<Array<CommunicationRecord>> = new PagedResult<Array<CommunicationRecord>>([]);

  private _searchParams: CommunicationRecordSearch = new CommunicationRecordSearch();

  /**
   * inject
   */
  public constructor(
    private _massCommService: MassCommService,
    private _navigationService: NavigationService,
    private _datagridService: DatagridService
  ) {}

  /**
   * for the ngprime data table
   */
  public lazyLoad($event: any): void {
    this._datagridService.mapDatagridPagingToPagedSearch($event, this._searchParams);

    if (!this.isSearching) this.getRecipients();
  }

  /**
   * user wants to export
   */
  public handleExportToExcelClick(): void {
    this.exportDetailsToExcel();
  }

  /**
   * load recipients for grid
   */
  private async getRecipients(): Promise<void> {
    if (this.isSearching || this.messageId <= 0) return;

    this.isSearching = true;

    this._searchParams.MessageId = this.messageId;

    try {
      let result: PagedResult<Array<CommunicationRecord>> = await this._massCommService.searchCommunicationRecords(this._searchParams);

      if (result) {
        this._datagridService.mapPagedResultsToPagedSearch(result, this._searchParams);
        this.recipientResult = result;
      } else {
        this.recipientResult.Result = [];
      }
    } catch (e) {
    } finally {
      this.isSearching = false;
    }
  }

  /**
   * export to excel
   */
  private async exportDetailsToExcel(): Promise<void> {
    if (this.isExporting) return;

    this.isExporting = true;

    try {
      let url: string = await this._massCommService.exportCommunicationRecordsAsExcel(this._searchParams);

      this._navigationService.popupSafeNavigate(url);
    } catch (e) {
    } finally {
      this.isExporting = false;
    }
  }
}
